import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import ConfirmButton from '../../../../components/confirm-button';
import { Modal, Button } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import UserAvatar from 'react-user-avatar';

import { requestUnassignPIUserOrganizations } from '../../AdminActions';
import styles from './styles.css';


class UserOrganizationRow extends Component {
  constructor() {
    super();
    this.state = {
      deleting: false,
      error: null,
      showModal: false,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  close() {
    this.setState({ showModal: false, error: null });
  }

  open() {
    this.setState({ showModal: true });
  }

  handleDelete() {
    const { organization, user } = this.props;
    this.setState({ deleting: true, error: null });
    this.props.dispatch(requestUnassignPIUserOrganizations(user._id, organization._id))
      .then(
        () => {
          this.props.onDelete(organization);
          if (this.mounted) {
            // this.setState({ deleting: false, error: null });
          }
        },
        (error) => {
          this.setState({ deleting: false, error: error.data || error });
          this.open();
        },
      );
  }

  renderModal() {
    const { error, showModal } = this.state;
    return (
      <Modal show={showModal} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error !== null && <p className="text-danger"><Fa name="hand-stop-o" /> {error.message}</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.close}>OK</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { deleting } = this.state;
    const { organization } = this.props;
    const displayName = organization.display_name || organization.name;
    return (
      <tr key={organization._id}>
        <td width="20">
          <div className={styles.orgPhoto}>
            <UserAvatar borderRadius="2px" name={displayName} size="24" />
          </div>
        </td>
        <td>
          {displayName}
        </td>
        <td className="text-right">
          {!deleting && <ConfirmButton size="xs" confirmStyle="link" onConfirm={this.handleDelete}>
            <span><Fa name="times-circle" className="text-danger" /></span>
          </ConfirmButton>}
          {deleting && <button type="button" disabled={deleting} className="btn btn-xs btn-default">
            <Fa spin name="spinner" />
          </button>}
        </td>
      </tr>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

UserOrganizationRow.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
};
UserOrganizationRow.defaultProps = {
  onDelete: () => {},
};

export default connect(mapStateToProps)(UserOrganizationRow);
